import React from 'react';
import { connect } from 'react-redux';

import { compose } from 'shared/helpers';
import { compDidCatchError } from 'shared/actions/debug';


const DefaultErroredView = () => (
  <div className="mt6 moa-ff-sans tc">
    <h3>Something went wrong :(</h3>
  </div>
);


/*
 * ErrorBoundary
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, info) {
    this.props.compDidCatchError({ error, info });
    this.setState({ hasError: true });
  }

  componentDidUpdate() {
    const { hasError } = this.state;
    const { onErrored } = this.props;

    if (hasError && typeof onErrored === 'function') {
      // IMPORTANT: Here it is assumed that onErrored callback
      // will "rollback" children to last known good state;
      // hence we call set hasError back to false.
      onErrored();
      this.setState({ hasError: false });
    }
  }

  render() {
    const {
      children,
      fallback = <DefaultErroredView />,
    } = this.props;

    return this.state.hasError ? fallback : children;
  }
}


// export default ErrorBoundary;
export default compose(
  connect(null, { compDidCatchError }),
)(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/components/utils/ErrorBoundary.js